import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'block';

export const { focus } = createLifecycleFor(TYPE);
